export default "__VITE_ASSET__rgzNcxBf__"